export interface UserLogin {
  token: string;
  user: User
}

export interface User {
  active: boolean,
  associate: {
    active: boolean,
    address_id: string;
    id: string;
    type: string;
    user_id: string
  },
  image?:string,
  id: string,
  password_recovery_id: any,
  profile: {
    address_id: string
    attendsChurch: boolean
    churchAttendance: string
    churchName: string
    fullName: string
    id: string
    image: string
    image_id: string
    reasonOfInterestInReligion: string
    timeAttendingChurch: string
    wantToKnowMoreAboutReligion: string
  },
  role: {
    id: string;
    name: string
  },
  role_id: number,
  userName: string
}
